<template>
    <v-app id="inspire">
        <app-navigation v-if="$route.path !== '/login'" />
        <v-main
            id="principal"
            height="100%"
            width="100px"
            :class="{
                'pa-0 main-bvs':
                    $route.path === '/login-bvs' || $route.path === '/login'
            }"
        >
            <router-view />
        </v-main>
    </v-app>
</template>

<style scoped>
.main-bvs :deep(.v-main__wrap) {
    padding: 0 !important;
}
</style>

<style>
.is-partner .v-input.v-input--is-dirty .v-input--switch__track {
    background-color: #cdf3ff !important;
    border-color: #cdf3ff !important;
}
</style>

<script>
import AppNavigation from '@/components/AppNavigation';
import Vue from 'vue';
import VueNumber from 'vue-number-animation';

Vue.use(VueNumber);

export default {
    name: 'App',
    components: {
        AppNavigation
    },
    data: () => ({
        //
    }),
    computed: {
        isPartner() {
            return this.$store.getters.isPartner == 1;
        }
    },
    watch: {
        isPartner(newVal) {
            if (newVal) {
                document.body.classList.add('is-partner');
            } else {
                document.body.classList.remove('is-partner');
            }
        }
    },
    mounted() {
        //
    }
};
</script>
